import { SearchComponent } from "@/utils/search/types/searchComponent";

import { NumberOfHitsConfigurationEntry } from "./numberOfHits.types";

export const SEARCH_PRODUCT_ID = "search__product";
export const SEARCH_CONTENT_ID = "search__content";

export const NumberOfHitsConfiguration: Array<NumberOfHitsConfigurationEntry> =
    [
        {
            component: SearchComponent.PRODUCT_NUMBER_OF_HITS,
            translationKey: "search.results.name.products",
            resultListId: SEARCH_PRODUCT_ID
        },
        {
            component: SearchComponent.CONTENT_NUMBER_OF_HITS,
            translationKey: "search.results.name.contentPages",
            resultListId: SEARCH_CONTENT_ID
        }
    ];
